<template>
    <div class="imgList">
        <ul>
            <li v-for="(item,index) in list" :key="index">
                <a :href="`#/wkdetail/${item.bookname}/${item.id}`">
                    <p>
                        <img v-lazy="item.covImgUrl" alt="" />
                    </p>
                    <p>{{item.title}}</p>
                    <p>老师：{{item.speaker}}</p>
                    <p>时长：{{item.duration}}</p>
                </a>
            </li>
        </ul>
        <div class="live-bottom" v-if="list.length > 0"><span>已展示全部内容</span></div>        
    </div>
</template>

<script>
import jsonp from 'jsonp';

export default{
    name: 'ImgList',
    props:{
        list: Array
    },
    data(){
        return{
            name: encodeURI(this.$route.params.title),
            sortid: this.$route.params.sortid
        }
    }
}
</script>

<style lang="less" scoped>
    .imgList{
        padding-bottom: 1.5rem;
        li{
            padding: 0 0.05rem;
            margin-bottom: 0.45rem;
            img{
                width: 100%;
            }
            p{
                font-size: 0.36rem;
                color: #333;
                margin-top: 0.15rem;
                &:nth-last-of-type(1){
                    font-size: 0.32rem;
                    color: #888;
                }
            }
        }
    }              
</style>   